export class LicenseWizardRequestDto {

	public requestType: string;
	public encodedProductKey: string;
	public activationResponse: string;

	constructor(requestType: string) {
		this.requestType = requestType;
	}
}